export default "__VITE_ASSET__cObzB5_N__"